var getBuiltIn = require(147);

module.exports = getBuiltIn('document', 'documentElement');
